import { type FieldValues, useController } from 'react-hook-form';
import type {
  FormControlProps,
  TypedUseControllerProps,
} from '../FormControl/FormControl.types';
import { IPSubnetField } from '../IPSubnetField/IPSubnetField';
import type {
  IPSubnetFieldType,
  IPSubnetInputValueOrDraft,
} from '../IPSubnetInput/IPSubnetInput.types';

export type FormIPSubnetFieldProps<
  TFieldValues extends FieldValues = FieldValues,
> = TypedUseControllerProps<TFieldValues, IPSubnetInputValueOrDraft> &
  FormControlProps<IPSubnetFieldType>;

export const FormIPSubnetField = <
  TFieldValues extends FieldValues = FieldValues,
>({
  disabled,
  ...props
}: FormIPSubnetFieldProps<TFieldValues>) => {
  const {
    field: { ref, ...field },
    formState: { errors },
  } = useController(props);

  const error = errors[props.name]?.message?.toString();

  return (
    <IPSubnetField
      {...props}
      {...field}
      value={field.value}
      inputRef={ref}
      disabled={disabled}
      error={error}
    />
  );
};
